import { render } from "./MaterialsPage.vue?vue&type=template&id=02f352ef&ts=true"
import script from "./MaterialsPage.ts?vue&type=script&lang=ts"
export * from "./MaterialsPage.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__